import PropTypes from "prop-types";
import styles from "./index.css";
import CurrentPrice from "../CurrentPrice";
import CurrentPricePrefix from "../CurrentPricePrefix";
import ProductDiscountLabel from "../ProductDiscountLabel";
import getItemPriceAriaLabel from "./getItemPriceAriaLabel";
import getPriceInfo from "../../../../getPriceInfo";

const ProductPriceComponents = ({
  discount,
  price,
  hasMultiplePricesInStock,
  variantId,
  showDiscountLabel,
  labelledById,
  discountLabelledById,
  OriginalPriceComponent,
  rowVisibilityRef
}) => {
  const priceInfo = getPriceInfo({ price });
  const { originalPrice, isDiscounted, isOutlet, previousEndDate } = priceInfo;

  return (
    <div
      className={styles.pricing}
      id={labelledById}
      aria-hidden={true}
      aria-label={getItemPriceAriaLabel({
        priceInfo,
        hasMultiplePricesInStock,
        variantId
      })}
    >
      <ProductDiscountLabel
        discount={discount}
        labelledById={discountLabelledById}
        showDiscountLabel={showDiscountLabel}
        className={styles.productDiscountLabel}
      />
      <div className={styles.productPrice} aria-hidden={true}>
        <CurrentPrice
          priceInfo={priceInfo}
          hasMultiplePricesInStock={hasMultiplePricesInStock}
          variantId={variantId}
          Prefix={CurrentPricePrefix}
          rowVisibilityRef={rowVisibilityRef}
        />
        {isDiscounted && (
          <OriginalPriceComponent
            originalPrice={originalPrice}
            isOutlet={isOutlet}
            previousEndDate={previousEndDate}
          />
        )}
      </div>
    </div>
  );
};

ProductPriceComponents.propTypes = {
  price: PropTypes.shape({
    current: PropTypes.shape({ value: PropTypes.number.isRequired }).isRequired,
    previous: PropTypes.shape({ value: PropTypes.number }).isRequired,
    rrp: PropTypes.shape({ value: PropTypes.number }).isRequired,
    isOutletPrice: PropTypes.bool
  }).isRequired,
  hasMultiplePricesInStock: PropTypes.bool.isRequired,
  variantId: PropTypes.number,
  discount: PropTypes.number.isRequired,
  discountLabelledById: PropTypes.string,
  showDiscountLabel: PropTypes.bool.isRequired,
  labelledById: PropTypes.string.isRequired,
  OriginalPriceComponent: PropTypes.elementType.isRequired,
  rowVisibilityRef: PropTypes.func
};

export default ProductPriceComponents;
